import { Link } from "react-router-dom";

import "./SettingsIndex.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Button, Col } from "react-bootstrap";

import { useEffect, useState } from "react";
import { useAuth } from "../../../context/authContext";
import { MenuList } from "../../layouts/nav/Menus";
import { SVGICON } from "../../constant/theme";
const SettingsIndex = () => {
  const { user } = useAuth();
  const [filteredMenuList, setFilteredMenuList] = useState([]);
  useEffect(() => {
    const filteredList = MenuList.filter((menu) => {
      // Find matching module from allowedModules
      const module = user?.allowedModules?.find(
        (mod) =>
          mod.value === menu.eventKey &&
          menu.eventKey.toLocaleLowerCase() == "settings"
      );

      // Check if the module exists and has "menu" operation
      if (!module || !module.operations.includes("menu")) return false;

      // If the menu has mainArray, filter its content
      if (menu?.mainArray) {
        menu.mainArray = menu.mainArray.filter((subMenu) =>
          user.allowedModules.some(
            (mod) =>
              mod.value.trim() === subMenu.eventKey.trim() &&
              mod.operations.includes("menu")
          )
        );
      }

      if (menu?.content) {
        menu.content = menu.content.filter((subMenu) =>
          user.allowedModules.some(
            (mod) =>
              mod.value.trim() === subMenu.eventKey.trim() &&
              mod.operations.includes("menu")
          )
        );
      }

      return true;
    });

    setFilteredMenuList(filteredList[0]?.mainArray);
  }, []);
  return (
    filteredMenuList &&
    filteredMenuList.length > 0 && (
      <>
        <Card>
          <Card.Title>All Settings</Card.Title>
          <hr />
          <Card.Body className="noWrap">
            {filteredMenuList.map((item, index) => {
              {
                return item.content.map((c, i) => {
                  return (
                    <Col
                      md={3}
                      className="settingCard"
                      key={`settings-'${index}-${i}`}
                      style={{ width: "17rem" }}
                    >
                      <div className="setting-icon mb-2">
                        {c.iconStyle ? (
                          <span
                            dangerouslySetInnerHTML={{ __html: c.iconStyle }}
                          />
                        ) : (
                          SVGICON.SettingIcon
                        )}
                      </div>
                      <h6 style={{ color: "black" }}>{item.title}</h6>
                      <p style={{ color: "gray" }}>{c.title}</p>
                      {item.to}
                      <Link to={`/${c.to}`} rel="noopener noreferrer">
                        <Button className="setting-button">
                          Go to Setting
                        </Button>
                      </Link>
                    </Col>
                  );
                });
              }
            })}
          </Card.Body>
        </Card>
      </>
    )
  );
};

export default SettingsIndex;
